import { capitalDesignTokens } from "@opengov/capital-design-tokens";
const MuiPickersLayout = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      "& .MuiPickersLayout-actionBar": {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
      },
      "& .MuiDateRangePickerToolbar-container": {
        "& .MuiTypography-root": {
          fontSize: capitalDesignTokens.foundations.typography.fontSize.h3
        },
        "& .MuiButton-root": {
          minHeight: 1
        }
      },
      "& .MuiList-root": {
        border: "none",
        boxShadow: "none"
      }
    })
  }
};
export {
  MuiPickersLayout
};
//# sourceMappingURL=MuiPickersLayout.js.map
